package hk.com.vr360_demo2.webapp.component.viewer.component


import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import web.cssom.*
import web.cssom.FlexDirection

external interface SwitchSpaceButtonProps : Props {
    var onSwitch: (() -> Unit)?
    var label: String?
}

val SwitchSpaceButton = FC<SwitchSpaceButtonProps> { props ->
    div {
        css {
            display = Display.flex
            flexDirection = FlexDirection.column
            alignItems = AlignItems.center
            cursor =  Cursor.pointer

            color = NamedColor.white
            gap = 4.px
        }
        onClick = { props.onSwitch?.invoke() }
        img {
            src = "/assets/images/switch.svg"
            alt = "選擇場景"
            css {
                width = 24.px
                height = 24.px
            }
        }
        div {
            css { fontSize = 14.px
                asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                    display = "none".unsafeCast<Display>()
                }}

            +(props.label ?: "選擇場景")
        }
    }
}
